// Whether the signed-in user has a sent bank-transfer invoice waiting for payment (the fullstack's
// /api/v1/user/stripe/pending-invoice): the banner then says Pay Now, and #register opens at that
// invoice. Checked when the sign-in state changes; signed out, there is none.

import {ref, watch} from "vue";
import useUserSafe from "@/composables/useUserSafe";
import {authFetch, readJson} from "@/composables/useAuthFetch";

const hasPendingInvoice = ref(false); // shared by every banner on the page

async function fetchHasPendingInvoice() {
  const response = await authFetch("/api/v1/user/stripe/pending-invoice");
  if (!response.ok) return false;
  const {invoice} = await readJson(response);
  return Boolean(invoice?.id);
}

export default function usePendingInvoice() {
  const {isSignedIn} = useUserSafe();
  watch(isSignedIn, async (signedIn) => {
    hasPendingInvoice.value = signedIn ? await fetchHasPendingInvoice() : false;
  }, {immediate: true});
  return {hasPendingInvoice};
}
